module.exports = __webpack_public_path__ + "img/pic_15.90e45f51.jpg";